import { styled, Chip, chipClasses } from '@mui/material';

export const MarkerDeliveryVehicleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  marginBottom: '5px',
});

export const MarkerDeliveryVehicleChip = styled(Chip)(({ theme }) => ({
  ...theme.typography.caption,
  fontSize: theme.typography.pxToRem(9),
  fontWeight: theme.typography.fontWeightBold,
  cursor: 'inherit',
  height: 'auto',
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.shadows[1],
  border: `1px solid ${theme.palette.divider}`,
  zIndex: 1,

  [`& .${chipClasses.label}`]: {
    paddingRight: theme.spacing(1),
  },
}));

export const MarkerDeliveryVehicleArrow = styled('span')(({ theme }) => ({
  overflow: 'hidden',
  position: 'absolute',
  width: 15.5,
  height: 11,
  boxSizing: 'border-box',
  color: theme.palette.common.black,
  bottom: 0,
  left: '50%',
  transform: 'translate(-50%, -2px)',
  marginBottom: '-10px',

  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'currentColor',
    transform: 'rotate(45deg)',
    transformOrigin: '100% 0',
  },
}));
